import { http } from 'services';

export function getDay(type, id, dayID, cbSuccess, cbError) {
  http.get(
    `${type}/${id}/days/${dayID}`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function editDay(type, id, dayID, payload, cbSuccess, cbError) {
  http.put(
    `${type}/${id}/days/${dayID}`,
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function copyDay(type, id, dayID, payload, cbSuccess, cbError) {
  http.post(
    `${type}/${id}/days/${dayID}/make-copy`,
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function manageDays(type, id, payload, cbSuccess, cbError) {
  http.post(
    `${type}/${id}/manage-days`,
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function getDaySummary(type, id, dayID, cbSuccess, cbError) {
  http.get(
    `${type}/${id}/days/${dayID}/summary`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function recreateDaySummary(type, id, dayID, cbSuccess, cbError) {
  http.post(
    `${type}/${id}/days/${dayID}/recreate-summary`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}



// WEBPACK FOOTER //
// ./src/api/api-programs/api-programs-day.js